import React from 'react';
import './CobbAngleMeasurement.css';
const CobbAngleMeasurement = ({ measurement }: any) => {
  return <div className="cobb-angle-measurement">dima</div>;
};

export default CobbAngleMeasurement;
